import DivSelectField from "../DivSelectField/DivSelectField";
import AutocompleteField from "../AutocompleteField/AutocompleteField";
import PropTypes from "prop-types";
import useFieldTable from "../../../hooks/useFieldTable";
import useField from "../../../hooks/useField";

function AutocompleteFieldTable(props) {
  const { fieldTableRef, isSelected, onSelectField, onBlur } = useFieldTable();

  const { inputStyleTable } = useField();

  const onChangeLocal = (event, value_object, value_key, state_value_name) => {
    props.onChange(event, value_object, value_key, state_value_name, props.index);
    onBlur(event);
  };

  const onBlurLocal = (event) => {
    setTimeout(() => {
      onBlur(event);
    }, 200);
  };

  return (
    <>
      {isSelected ? (
        <AutocompleteField
          style={{
            fontSize: "0.875rem",
            borderRadius: 0,
            textAlign: "center",
            ...inputStyleTable,
            minWidth: "150px"
          }}
          sx={{
            ".MuiOutlinedInput-notchedOutline": {
              borderColor: props.showBorder ? undefined : "transparent",
            },
            ".MuiOutlinedInput-input": {
              padding: 0,
            },
          }}
          name={props.name}
          value={props.value}
          options={props.options}
          onChange={onChangeLocal}
          isObjectOption={props.isObjectOption}
          optionLabelKey={props.optionLabelKey}
          optionValueKey={props.optionValueKey}
          readOnly={props.readOnly}
          multiple={props.multiple}
          showExternalButton = {props.showExternalButton}
          onClickAddItemToAutocompletedField = {props.onClickAddItemToAutocompletedField}
          ref={fieldTableRef}
          onBlur={onBlurLocal}
          open={isSelected}
        />
      ) : (
        <DivSelectField
          {...props}
          optionLabel={props.optionLabelKey}
          optionKey={props.optionValueKey}
          onSelectField={onSelectField}
          onFocus={onSelectField}
          multiple={props.multiple}
        />
      )}
    </>
  );
}

AutocompleteFieldTable.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
  isObjectOption: PropTypes.bool,
  optionLabelKey: PropTypes.string,
  optionValueKey: PropTypes.string,
  readOnly: PropTypes.bool,
  showBorder: PropTypes.bool,
  showExternalButton : PropTypes.bool,
  onClickAddItemToAutocompletedField : PropTypes.func
};

AutocompleteFieldTable.defaultProps = {
  readOnly: false,
  options: [],
  optionLabelKey: "name",
  optionValueKey: "id",
  showExternalButton : false
};

export default AutocompleteFieldTable;
